export type InternalUserIdentity = {
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
};

export const INTERNAL_CAPTURE_STORAGE_KEY = "gogive_posthog_skip_internal";

const GOGIVE_DOMAINS = new Set(["gogive.com.au", "gogive.com"]);
const INTERNAL_LOCAL_PART = /^(alex|alexandre|admin)(\+|$)/i;

function asRecord(value: unknown): Record<string, unknown> | null {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value as Record<string, unknown>;
  }
  return null;
}

function stringProp(value: unknown): string {
  return typeof value === "string" ? value : "";
}

function emailFromCurrentUrl(url: string): string {
  try {
    return new URL(url).searchParams.get("email") ?? "";
  } catch {
    return "";
  }
}

export function isInternalPostHogUser(user: InternalUserIdentity): boolean {
  const email = (user.email ?? "").trim().toLowerCase();
  const lastName = (user.lastName ?? "").trim().toLowerCase();

  if (lastName === "desbiez") return true;
  if (email.includes("desbiez")) return true;

  const at = email.lastIndexOf("@");
  if (at > 0) {
    const localPart = email.slice(0, at);
    const domain = email.slice(at + 1);
    if (GOGIVE_DOMAINS.has(domain) && INTERNAL_LOCAL_PART.test(localPart)) {
      return true;
    }
  }

  return false;
}

export function identityFromCaptureEvent(event: {
  properties?: Record<string, unknown> | null;
  $set?: Record<string, unknown> | null;
}): InternalUserIdentity {
  const properties = event.properties ?? {};
  const setProperties = {
    ...asRecord(properties.$set),
    ...(event.$set ?? {}),
  };

  return {
    email:
      stringProp(setProperties.email) ||
      stringProp(properties.email) ||
      emailFromCurrentUrl(stringProp(properties.$current_url)),
    firstName:
      stringProp(setProperties.first_name) || stringProp(properties.first_name),
    lastName:
      stringProp(setProperties.last_name) || stringProp(properties.last_name),
  };
}

export function shouldDropInternalCaptureEvent(event: {
  properties?: Record<string, unknown> | null;
  $set?: Record<string, unknown> | null;
}): boolean {
  return isInternalPostHogUser(identityFromCaptureEvent(event));
}

export function isInternalCaptureBlocked(): boolean {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(INTERNAL_CAPTURE_STORAGE_KEY) === "1";
}

export function persistInternalCaptureBlock(): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(INTERNAL_CAPTURE_STORAGE_KEY, "1");
}
